import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { bookingApi } from '../../utils/bookingApi';
import { useAuth } from '../../contexts/AuthContext';
import { useFeature } from '../../hooks/useFeature';

// A button that opens (or starts) a conversation, for staff with
// Communications: Manage when the club has messaging on
function OpenConversationButton({ label, open, className = 'bk-btn bk-btn--sm' }) {
  const { can } = useAuth();
  const messaging = useFeature('messaging');
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  if (!messaging || !can?.('communications', 'MANAGE')) return null;
  const go = async () => {
    setBusy(true);
    setError(null);
    try {
      const res = await open();
      navigate(`/booking/messages/${res.data.id}`);
    } catch (err) {
      setError(err.response?.data?.error || "Couldn't open the conversation");
      setBusy(false);
    }
  };
  return (
    <>
      <button type="button" className={className} onClick={go} disabled={busy}>{label}</button>
      {error && <span className="chat-error" role="alert">{error}</span>}
    </>
  );
}

// On a competition: the group of its accepted entrants
export const MessageEntrantsButton = ({ eventId, className }) => (
  <OpenConversationButton label="Message entrants" className={className} open={() => bookingApi.chatCompetitionGroup(eventId)} />
);

// On a member's page: their family's thread with the club
export const MessageFamilyButton = ({ userId, className }) => (
  <OpenConversationButton label="Message" className={className} open={() => bookingApi.chatOpenFamilyThread(userId)} />
);
